// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-PersonSelect-PersonSelect-module__label--A8Y0n {
  display: inline-block;
}
.src-components-PersonSelect-PersonSelect-module__label--A8Y0n * {
  display: inline;
}
`, "",{"version":3,"sources":["webpack://./src/components/PersonSelect/PersonSelect.module.less"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;AAFA;EAGI,eAAA;AAEJ","sourcesContent":[".label {\n  display: inline-block;\n  * {\n    display: inline;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `src-components-PersonSelect-PersonSelect-module__label--A8Y0n`
};
export default ___CSS_LOADER_EXPORT___;
